module.exports = __webpack_public_path__ + "static/media/is.d2d3cb26.svg";